module.exports = __webpack_public_path__ + "9788f41e/img/chevron-right-icon.253a4260.svg";